import React, {ErrorInfo} from 'react';
import Box from '@material-ui/core/Box';

class AppErrorBoundary extends React.Component<
  {},
  {hasError: boolean; error: Error | null}
> {
  constructor(props: any) {
    super(props);
    this.state = {hasError: false, error: null};
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return {hasError: true};
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    this.setState({error});
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          display='flex'
          alignItems='center'
          flexDirection='column'
          justifyContent='center'
          flex={1}>
          <img alt='Error Info' />
          <Box component='h1' fontSize={'7rem'}>
            500
          </Box>
          <Box component='h3' fontSize={'1.2rem'}>
            Internal Error
          </Box>
          <Box component='p' fontSize={'1rem'}>
            Sorry Something Went Wrong !
          </Box>
          <Box>{this.state.error && this.state.error.toString()}</Box>
        </Box>
      );
    } else {
      return this.props.children;
    }
  }
}

export default AppErrorBoundary;
